import React from 'react';
import MobileStoreButton from '@ertelecom/ui-react/components/buttons/mobileStoreButton';
import { PaddingWrapper, Bonus, Picture, Source, Img, WrapperText, Title, WrapperMobileBtn } from './styled';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

const AppLinks = ({ bgColor, nonTopPadding }) => {
    return (
        <PaddingWrapper bgColor={bgColor} nonTopPadding={nonTopPadding} nonBottomPadding>
            <GridContainer>
                <Bonus itemScope itemType='http://schema.org/ImageObject'>
                    <LazyLoadComponent>
                        <Picture>
                            <Source srcSet='/static/images/videocontrol/vc_iphone.webp' type='image/webp' />
                            <Img src='/static/images/videocontrol/vc_iphone.png' alt='приложение Умный Дом.ru' title='приложение Умный Дом.ru' itemProp='contentUrl'/>
                        </Picture>
                    </LazyLoadComponent>
                    <WrapperText>
                        <Title itemProp='name'>Скачайте приложение Умный&nbsp;Дом.ru</Title>
                        <WrapperMobileBtn>
                            <MobileStoreButton store='SmartAppStore' target='_blank' color='#000' />
                            <MobileStoreButton store='SmartGooglePlay' target='_blank' color='#000' />
                        </WrapperMobileBtn>
                    </WrapperText>
                    <LazyLoadComponent>
                        <Picture marginTop='0' maxWidth='155px'>
                            <Source srcSet='/static/images/videocontrol/qr-domofon.webp' type='image/webp' />
                            <Img src='/static/images/videocontrol/qr-domofon.jpg' alt='qr-код приложения Умный Дом.ru' title='qr-код приложения Умный Дом.ru' itemProp='contentUrl'/>
                        </Picture>
                    </LazyLoadComponent>
                </Bonus>
            </GridContainer>
        </PaddingWrapper>
    );
};

export default AppLinks;
